import React from "react";
import * as styles from "./SparkStar.module.scss";

type Props = {
  size?: number;
  color?: string;
  className?: string;
};

export const SparkStar: React.FC<Props> = ({
  size = 28,
  color = "#1c1c1c",
  className,
}) => (
  <svg
    className={`${styles.star} ${className ?? ""}`}
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M14 0L16.5 10.5L27 14L16.5 17.5L14 28L11.5 17.5L1 14L11.5 10.5L14 0Z"
      fill={color}
    />
    <path
      d="M24 2L25 6L28 7L25 8L24 12L23 8L20 7L23 6L24 2Z"
      fill={color}
    />
  </svg>
);

export default SparkStar;
